/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ManagerDetailsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 32 34"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="15" cy="4.38533333" r="3.69866667" />
      <path d="M20.9173333,14 L9.08266667,14 C9.08266667,10.7346667 11.7306667,8.08266667 15,8.08266667 C18.2706667,8.08266667 20.9173333,10.7346667 20.9173333,14 Z" />
      <circle cx="4.94533333" cy="23.944" r="2.66666667" />
      <path d="M9.672,31.336 L0.218666667,31.336 C0.218666667,28.7253333 2.33333333,26.6106667 4.94533333,26.6106667 C7.556,26.6106667 9.672,28.7253333 9.672,31.336 Z" />
      <circle cx="24.9453333" cy="23.944" r="2.66666667" />
      <path d="M29.672,31.336 L20.2186667,31.336 C20.2186667,28.7253333 22.3333333,26.6106667 24.9453333,26.6106667 C27.556,26.6106667 29.672,28.7253333 29.672,31.336 Z" />
      <circle cx="24.9453333" cy="23.944" r="2.66666667" />
      <path d="M29.672,31.336 L20.2186667,31.336 C20.2186667,28.7253333 22.3333333,26.6106667 24.9453333,26.6106667 C27.556,26.6106667 29.672,28.7253333 29.672,31.336 Z" />
      <circle cx="15" cy="23.944" r="2.66666667" />
      <path d="M19.7266667,31.336 L10.2746667,31.336 C10.2746667,28.7253333 12.3893333,26.6106667 15,26.6106667 C17.612,26.6106667 19.7266667,28.7253333 19.7266667,31.336 Z" />
      <polyline points="5 17.972 5 16.6666667 25 16.6666667 25 17.972" />
      <path d="M15,14 L15,17.972" />
    </g>
  </svg>
);

export default ManagerDetailsIcon;
